import { z } from "zod";
import { getPartnershipParamSchema } from "./get-partnership.schema";

export const deletePartnershipAgreementParamSchema = z
	.object({
		agreementId: z.string().uuid(),
	})
	.and(getPartnershipParamSchema);
